import { InterpretationRule } from 'components/OrganisationDetails/interpretation-rules/types';
import { api } from 'store/api';
import { ApiResponse } from 'store/api/types';
import { TOKEN_ID_HEADER } from 'store/app/constants';


export const saveRuleRequest = (
  applicationConnectionId: string,
  rule: InterpretationRule
) => {
  return api.post<ApiResponse>(
    `/auth/receipt/${applicationConnectionId}/rule`,
    {
      body: rule,
      headers: { [TOKEN_ID_HEADER]: applicationConnectionId },
    }
  );
};

export const updateRuleRequest = (
  applicationConnectionId: string,
  rule: InterpretationRule,
  ruleId: string
) => {
  return api.put<ApiResponse>(
    `/auth/receipt/${applicationConnectionId}/rule/${ruleId}`,
    {
      body: rule,
      headers: { [TOKEN_ID_HEADER]: applicationConnectionId },
    }
  );
};

export const getRulesForApplicationConnectionRequest = (
  applicationConnectionId: string
) => {
  return api.get<ApiResponse>(
    `/auth/receipt/${applicationConnectionId}/rule`,
    {
      headers: { [TOKEN_ID_HEADER]: applicationConnectionId },
    }
  );
};

export const getRuleForApplicationConnectionRequest = (
  applicationConnectionId: string,
  ruleId: string
) => {
  return api.get<ApiResponse>(
    `/auth/receipt/${applicationConnectionId}/rule/${ruleId}`,
    {
      headers: { [TOKEN_ID_HEADER]: applicationConnectionId },
    }
  );
};

export const enableDisableRuleRequest = (
  applicationConnectionId: string,
  ruleId: string,
  enabled: boolean
) => {
  return api.post<ApiResponse>(
    `/auth/receipt/${applicationConnectionId}/rule/${ruleId}?enabled=${enabled}`,
    {
      headers: { [TOKEN_ID_HEADER]: applicationConnectionId },
    }
  );
};

export const deleteRuleRequest = (
  applicationConnectionId: string,
  ruleId: string
) => {
  return api.delete<ApiResponse>(
    `/auth/receipt/${applicationConnectionId}/rule/${ruleId}`,
    {
      headers: { [TOKEN_ID_HEADER]: applicationConnectionId },
    }
  );
};

export const parseRuleRequest = (sentence: string, tcNames: string[]) => {
  return api.post<ApiResponse>(`/auth/receipt/parse/rule`, {
    body: {
      sentence: sentence,
      tcNames: tcNames,
    },
  });
};